import { useMutation, useQueryClient } from '@tanstack/react-query';

import { TeamBoardUpdateReq, teamApi } from '../api';
import { TEAM_DETAIL_QUERY_KEY, TEAM_TASKS_QUERY_KEY } from '../queries';

interface UpdateTeamBoardParams {
  teamId: string;
  boardId: string;
  teamBoardUpdateReq: TeamBoardUpdateReq;
}

export const useUpdateTeamBoard = () => {
  const queryClient = useQueryClient();

  const updateTeamBoardMutation = useMutation({
    mutationFn: ({ teamId, boardId, teamBoardUpdateReq }: UpdateTeamBoardParams) => {
      return teamApi.updateTeamBoard(teamId, boardId, teamBoardUpdateReq).then(({ data }) => data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TEAM_DETAIL_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: TEAM_TASKS_QUERY_KEY });
    },
  });

  return {
    updateTeamBoard: updateTeamBoardMutation.mutateAsync,
    isUpdatingTeamBoard: updateTeamBoardMutation.isPending,
    ...updateTeamBoardMutation,
  };
};
